<div #panelTitle class="panel-title w-full flex flex-col bg-surf-container-lowest">
    <ng-container *ngIf="!isSingleRow">
        <div
            class="flex flex-col gap-2 py-2 adjustable-padding-top adjustable-padding-bottom adjustable-gap adjustable-side-padding"
            [ngClass]="{ separator: separator }"
        >
            <div class="h-6 flex items-center justify-between gap-2">
                <ng-container [ngTemplateOutlet]="dataSourceTemplate"></ng-container>
                <ng-container [ngTemplateOutlet]="panelRightTemplate"></ng-container>
            </div>
            <ng-container [ngTemplateOutlet]="titleMainTemplate"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="isSingleRow">
        <div
            class="flex items-center justify-between gap-2 py-2 adjustable-padding-top adjustable-padding-bottom adjustable-side-padding"
            [ngClass]="{ separator: separator }"
        >
            <ng-container [ngTemplateOutlet]="titleMainTemplate"></ng-container>
            <ng-container [ngTemplateOutlet]="panelRightTemplate"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="panelTools">
        <ng-container *ngIf="!showPanelToolsInTitle">
            <div class="my-1">
                <ng-container [ngTemplateOutlet]="panelToolsTemplate"></ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #dataSourceTemplate>
    <div class="data-source min-w-0 grow-0 h-6 flex items-center justify-center">
        <fui-badge
            class="min-w-0 max-w-full"
            [link]="dataSource.link"
            [title]="dataSource.label"
            [queryParams]="dataSource.queryParams"
            [tooltip]="dataSource.tooltip ?? appService.language_dictionary.data_source"
            icon="database"
            [color]="colorMarker"
            [useBackground]="true"
            [useOneLine]="true"
            size="small"
        ></fui-badge>
    </div>
</ng-template>

<ng-template #panelRightTemplate>
    <div class="flex shrink-0 gap-2 panel-right">
        <ng-container slot="buttonsRight">
            <ng-content select="[slot=buttonsRight]"> </ng-content>
        </ng-container>
        <ng-container *ngIf="buttonPanelConfig && !isMassEditing && !isNewItem">
            <fui-buttons-panel
                [buttons]="buttonPanelConfig.buttons$ | async"
                (buttonClick)="callParent($event.name, itemData)"
            >
            </fui-buttons-panel>
        </ng-container>
        <ng-container *ngIf="panelTools">
            <ng-container *ngIf="showPanelToolsInTitle" [ngTemplateOutlet]="panelToolsTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="showCloseButton">
            <fui-button
                title="{{ appService.language_dictionary.system_close }}"
                icon="close"
                height="slim"
                color="flat"
                iconSize="14"
                type="button-icon"
                (clickEvent)="callParent('closePage', itemData)"
            >
            </fui-button>
        </ng-container>
    </div>
</ng-template>

<ng-template #titleMainTemplate>
    <ng-container *ngIf="!isMassEditing">
        <div class="flex min-w-0 flex-1 items-center justify-between gap-1">
            <ng-container *ngIf="!isNewItem; else new">
                <div class="color-marker shrink-0 flex items-center justify-center" *ngIf="colorMarker && !dataSource">
                    <div class="w-4 h-4 rounded" [ngStyle]="{ 'background-color': colorMarker }"></div>
                </div>
                <div class="shrink-0 flex items-center justify-center" *ngIf="titleIcon">
                    <div class="w-4 h-4 text-base leading-4">
                        <i [ngClass]="'mdi mdi-' + titleIcon"></i>
                    </div>
                </div>
                <h2
                    class="title adjustable-title min-w-0 flex-auto"
                    #cardTitle
                    *ngIf="title; else empty"
                    (click)="titleExpandable && toggleTitle()"
                    [matTooltip]="titleExpandable && titleCollapsed ? tooltipText : null"
                >
                    <div #cardTitleText [ngClass]="{ collapsed: titleCollapsed, expandable: titleExpandable }">
                        <span [innerHTML]="title" (click)="callParent('titleClick', {})"></span>
                    </div>
                </h2>
            </ng-container>
            <ng-template #empty>
                <h2 class="title adjustable-title text-secondary-neutral-content-disabled">
                    {{ appService.language_dictionary.title_not_set }}
                </h2>
            </ng-template>
            <ng-template #new>
                <h2 class="title adjustable-title text-secondary-neutral-content-disabled">
                    {{ appService.language_dictionary.title_will_appear_after_item_saved }}
                </h2>
            </ng-template>
        </div>
    </ng-container>
    <ng-container *ngIf="isMassEditing">
        <div>
            <ng-content select="[slot=massEditing]" *ngIf="isMassEditing"></ng-content>
        </div>
    </ng-container>
</ng-template>

<ng-template #panelToolsTemplate>
    <panel-tools
        class="adjustable-side-padding panel-tools"
        [helpLink]="helpLink"
        [showRequiredLabel]="panelTools.showRequiredLabel"
        [showCloseButton]="panelTools.showCloseButton"
        [showLangButton]="panelTools.showLangButton"
        [buttonMenuConfig]="{
            color: 'soft-outline',
            borderRadius: 'rounded',
        }"
        [helpButtonConfig]="{
            color: 'soft-outline',
            borderRadius: 'rounded',
        }"
        (panelClick)="callParent($event.name, itemData)"
        (setCurrentLangForm)="setCurrentLangForm($event)"
        [buttonsHeight]="'slim'"
        [buttons]="panelTools?.buttons"
    >
        <ng-container slot="extraRightBlock">
            <ng-content select="[slot=extraRightBlock]"> </ng-content>
        </ng-container>
    </panel-tools>
</ng-template>
